import Cookies from 'js-cookie';
import { getLocalStorage } from './storage';
import { ExperienceDetails } from 'types/ProductDetailsType';
import { getCustomData } from './customData';

export enum PossibleGtmEventNames {
  CONTENT_GATE_CHECKED = 'contentGateChecked',
  REGISTRATION_INITIATION = 'registrationInitiation',
  REGISTRATION_SUBMISSION = 'registrationSubmission',
}

const logGtmEvent = (eventName: PossibleGtmEventNames, user?: any) => {
  const sessionId: string =
    (typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem('sessionId')) ||
    Cookies.get('sessionId') ||
    '';
  const userDateOfBirth: string =
    getLocalStorage().getItem('ageGateBirthDate') || '';
  const gdprRegion: boolean =
    Intl.DateTimeFormat().resolvedOptions().timeZone.indexOf('Europe') === 0 ||
    false;
  const details = JSON.parse(
    getLocalStorage().getItem('brijProductDetails') || '{}'
  );

  const w: any = window;
  const experienceDetails: ExperienceDetails =
    details?.product?.experienceDetails;

  const customDataObject = getCustomData();
  const hasCustomData = Object.keys(customDataObject).length > 0;
  const customData = hasCustomData
    ? Object.entries(customDataObject).map(([key, value]) => ({
        key,
        value,
      }))
    : [];

  if (w && w?.dataLayer) {
    w.dataLayer.push({
      event: `brij.${eventName}`,
      sessionId: sessionId,
      gdprRegion: gdprRegion,
      ...(experienceDetails && { experienceDetails: experienceDetails }),
      ...(hasCustomData && { customData: customData }),
      user: {
        ...user,
        ...(userDateOfBirth && { dateOfBirth: userDateOfBirth }),
      },
    });
  }

  return;
};

export default logGtmEvent;
